import styled from "@emotion/styled";

import NumericInput from "metabase/components/NumericInput";

export const IntervalInput = styled(NumericInput)`
  border-color: var(--mb-color-filter);
`;
